import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { trackEventOnClick } from "@faire/web--source/common/trackEvent";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
export var SignIn = function(param) {
    var loginUrl = param.loginUrl;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.subdued,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "QzveJb",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Already shopping on Faire?"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(EmbeddedLink, {
                    color: Core.text.subdued,
                    linkTo: loginUrl,
                    replace: true,
                    onClick: trackEventOnClick("elevate-sign-up/landing-page/click/log-in"),
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "Ub+AGc",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Sign In"
                            }
                        ]
                    })
                })
            })
        ]
    });
};
